import { Injectable } from '@angular/core';
import { fromEvent, map, Observable, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  observeWidthSmallerThan(width: number): Observable<boolean> {
    return fromEvent(window, 'resize').pipe(
      map(() => window.innerWidth),
      startWith(window.innerWidth), // Emit initial value
      map(w => w < width), // Only emit when width is smaller than 600px
    );
  }
}
